import { ActionTypes } from "../Constants/ActionTypes";
export const EditBreakDown = (dispatch, editBreakDownData) => {
  dispatch({
    type: ActionTypes.EDIT_BREAKDOWN,
    payload: editBreakDownData,
  });
};

export const OpenBreakDownPopup = (dispatch, status) => {
  dispatch({
    type: ActionTypes.OPEN_OR_CLOSE_BREAKDOWNPOPUP,
    payload: status,
  });
};

export const CloseEditBreakDownPopup = (dispatch, status) => {
  dispatch({
    type: ActionTypes.CLOSE_EDIT_BREAKDOWN_POPUP,
    payload: status,
  });
};
